module.exports = __webpack_public_path__ + "static/media/ecobux-WhitePaper.9564af08.pdf";